import { Route } from 'react-router-dom'
import { EditPage } from 'pages/my-calendars/edit-calendar'
import { InfoPage } from 'pages/my-calendars/info-calendar'
import { AuthenticationPage } from 'pages/authentication'
import { AuthorizationPage } from 'pages/authorization'
import { MyCalendarsPage } from 'pages/my-calendars'
import { AddCalendarForm } from 'pages/my-calendars/add-calendar-form'
import { AddCalendar } from 'pages/my-calendars/add-calendar'
import {
    ROOT,
    AUTHORIZATION,
    MY_CALENDARS,
    ADD_CALENDAR,
    ADD_CALENDAR_FORM,
    INFO_CALENDAR,
    EDIT_CALENDAR
} from 'shared/consts'
import { SupplierCalendarsContextProvider } from 'contexts/SupplierCalendarsContext'
import ProtectedRoute from 'shared/components/ProtectedRoute/ProtectedRoute'

const Routes = (): JSX.Element => {
    return (
        <>
            <SupplierCalendarsContextProvider>
                <Route path={AUTHORIZATION}>
                    <AuthorizationPage />
                </Route>
                <Route path={MY_CALENDARS} exact>
                    <MyCalendarsPage />
                </Route>
                <Route path={ADD_CALENDAR_FORM}>
                    <AddCalendarForm />
                </Route>
                <Route path={ADD_CALENDAR}>
                    <AddCalendar />
                </Route>
                <Route path={INFO_CALENDAR}>
                    <InfoPage />
                </Route>
                <ProtectedRoute
                    path={EDIT_CALENDAR}
                    component={EditPage}
                    redirectTo={MY_CALENDARS}
                />
                <Route path={ROOT} exact>
                    <AuthenticationPage />
                </Route>
            </SupplierCalendarsContextProvider>
        </>
    )
}

export default Routes
